/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient').controller('NodeSyncController', [
    '$scope',
    '$modalInstance',
    '$translate',
    'fileSizeFilter',
    'template',
    'DateTools',
    'SYNC_STATUS',
    function ($scope, $modalInstance, $translate, fileSizeFilter, template, DateTools, SYNC_STATUS) {
        $scope.isSynced = $scope.node.synced !== SYNC_STATUS.NOT_SYNCED;

        $scope.nodeName = $scope.node.name;

        /**
         * Current sync state
         */
        $scope.form = {
            synced: null,
            syncName: $scope.nodeName
        };

        // When only one option is available to choose
        // a starting value will be the opposite one
        $scope.form.synced = $scope.isSynced ? SYNC_STATUS.NOT_SYNCED : SYNC_STATUS.SYNC_2_WAY;

        $scope.modal = $modalInstance.options;
        $scope.modal.title = '';
        /**
         * We have to be sure that translations are being loaded
         * before showing modal dialog - ASRV-9067.
         * It just fix modal title, not the problem in general.
         */
        $translate(
            $scope.isSynced ? 'node_sync_action_unsync_title' : 'node_sync_action_sync_title',
            { folder_name: $scope.nodeName }
        ).then(function (translation) {
            $scope.modal.title = translation;
        });

        $scope.modal.bodyTemplate = template('nodes/sync_toggle');
        $scope.modal.actionButton = $translate.instant(
            $scope.isSynced ? 'node_sync_action_stop_sync_button_label' : 'Sync'
        );

        if ($scope.isInitialFolderSync) {
            $scope.modal.cancelButton = $translate.instant('Not now');
        }

        $scope.isSyncNameAvailable = true;
        $scope.nodeContentsSizeString = '';

        var getContentsSizeParams = $scope.node.uuid ? { uuid: $scope.node.uuid } : { id: $scope.node.id };

        $scope.node.$getContentsSize
            .call(null, getContentsSizeParams)
            .then(function (data) {
                $scope.isSyncNameAvailable = data['sync_name_available'];
                $scope.nodeContentsSizeString = ' (' + fileSizeFilter(data['contents_size']) + ')';
                $scope.modal.title += $scope.nodeContentsSizeString;
            });

        $scope.displayNote = !$scope.hasDesktopClient || DateTools.daysSince($scope.lastSyncWithDesktop) > 30;

        $scope.ok = function () {
            $modalInstance.close($scope.form);
        };

        $scope.close = $scope.cancel = function () {
            $modalInstance.dismiss();
        };

        $scope.disableSubmit = function () {
            return (
                !$scope.isSynced &&
                !$scope.isSyncNameAvailable &&
                ($scope.form.syncName.toUpperCase().trim() === $scope.nodeName.toUpperCase().trim() ||
                    $scope.form.syncName === '')
            );
        };
    }
]);
